
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-defi-framework/api/legacy/best_orders",
      function () {
        return require("private-next-pages/en/docs/komodo-defi-framework/api/legacy/best_orders/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-defi-framework/api/legacy/best_orders"])
      });
    }
  